import { render, staticRenderFns } from "./FormularioPedido.vue?vue&type=template&id=658345ae&scoped=true&"
import script from "./FormularioPedido.vue?vue&type=script&lang=js&"
export * from "./FormularioPedido.vue?vue&type=script&lang=js&"
import style0 from "./FormularioPedido.vue?vue&type=style&index=0&id=658345ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658345ae",
  null
  
)

export default component.exports